import React, { useEffect, useState } from 'react';
import Table from '../common/Table';
import tableConfig, { data, finishedOrdersTableConfig } from './config';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { GET_ORDERS } from '../../constants';
import { withRouter } from 'react-router-dom';
import './Orders.css';
import { CsvBuilder } from 'filefy';
import moment from 'moment';
import { useSelector } from 'react-redux';
import API from '../../utils/api';
import { Modal } from 'antd';
import Button from '../common/Button';

const Orders = props => {
  //console.log("order props",props);
  let session = sessionStorage.getItem('user');
  //const [countryid, setCountryid] = useState(session ? `${JSON.parse(session).countryId}` : "");

  const [countryid, setCountryid] = useState(1);

  const { totalCounts } = useSelector(state => state.login);

  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const showTimerModal = (orderDate, rowData) => {
    const orderTime = moment.utc(orderDate).local();
    const now = moment();
    const diff = now.diff(orderTime, 'minutes');

    if (diff > 3) {
      setSelectedOrder(rowData);
      setIsModalVisible(true);
    }
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedOrder(null);
  };

  const verifyPayment = async order_id => {
    try {
      console.log({ order_id });
      const checkPayment = await API.put(`/admin/verify-payment/${order_id}`);
      setRefreshTrigger(!refreshTrigger);
      // setTableKey(tableKey + 1)
    } catch (error) {
      console.log(error);
    }
  };

  const classes = props.classes;
  let config = tableConfig({ ...props, handleTimerClick: showTimerModal });
  const columnsConfig = finishedOrdersTableConfig(props, verifyPayment);
  const [value, setValue] = useState(0);
  const [dataSet, setData] = useState(data);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  //const onView = (rowdata) => console.log("rowdata", rowdata)
  const onView = rowdata => {
    props.history.push(`/orders/${rowdata.order_id}`);
  };
  const onDelete = () => {
    console.log('Delete');
  };

  const exportCsv = (columns, data) => {
    const columnTitles = columns.map(columnDef => columnDef.title);
    const csvExportData = [];
    const orderFileds = [
      { name: 'invoice_id', subField: '' },
      { name: 'delivery_task_id', subField: '' },
      { name: 'advance_booking', subField: '' },
      { name: 'cart', subField: 'no_of_items' },
      { name: 'net_amount', subField: '' },
      { name: 'delivery_option', subField: 'option_name' },
      { name: 'delivery_charges', subField: '' },
      { name: 'food_seller', subField: 'business_name' },
      { name: 'food_seller', subField: 'user', subField2: 'name' },
      { name: 'food_seller', subField: 'address_line1', subField2: '' },
      { name: 'food_seller', subField: 'pin_code', subField2: '' },
      { name: 'food_buyer', subField: 'user', subField2: 'name' },
      { name: 'food_buyer', subField: 'user', subField2: 'address_line1' },
      { name: 'food_buyer', subField: 'user', subField2: 'pin_code' },
      { name: 'order_date_system', subField: '', subField2: '' },
      { name: 'advance_booking_delivery_date', subField: '', subField2: '' },
      { name: 'fulfillment_status', subField: '', subField2: '' },
      { name: 'dunzo_status', subField: '', subField2: '' }
    ];

    const ordersData = data.map(order => {
      const ordersDataDetails = [];
      const orderData = orderFileds.map(orderFiled => {
        let orderValue = order[orderFiled.name];
        if (orderFiled.subField && orderValue) {
          orderValue =
            order[orderFiled.name] &&
            order[orderFiled.name][orderFiled.subField];

          if (orderFiled.subField2 && orderValue) {
            orderValue =
              order[orderFiled.name] &&
              order[orderFiled.name][orderFiled.subField] &&
              order[orderFiled.name][orderFiled.subField][orderFiled.subField2];
          }
        }

        if (orderFiled.name === 'advance_booking') {
          return orderValue ? 'Advance Booking' : 'Normal Booking';
        }

        if (orderFiled.name === 'food_seller_cuisine_mappings') {
          return orderValue
            .map(cuisineData =>
              cuisineData.cuisine ? cuisineData.cuisine.cuisine_name : ''
            )
            .join(', ');
        }

        if (
          orderFiled.name === 'order_date_system' ||
          orderFiled.name === 'advance_booking_delivery_date'
        ) {
          return moment
            .utc(orderValue)
            .local()
            .format('DD-MM-YYYY h:mm:ss a');
        }

        return orderValue;
      });

      ordersDataDetails.push(...orderData);
      return ordersDataDetails;
    });

    csvExportData.push(...(ordersData || []));

    const fileName =
      value === 0
        ? 'active-orders.csv'
        : value === 1
        ? 'in-deivery-orders.csv'
        : 'finshed-orders.csv';
    const builder = new CsvBuilder(fileName)
      .setColumns(columnTitles)
      .addRows(csvExportData);

    builder.exportFile();

    return builder;
  };

  return (
    <div>
      <Tabs
        classes={{ root: classes.tabRoot }}
        value={value}
        onChange={handleChange}
        className={{ root: classes.tabRoot }}
      >
        <Tab
          label={`Active Orders ${
            totalCounts.activeOrders > 0 ? `(${totalCounts.activeOrders})` : ''
          }`}
        />
        <Tab
          label={`Orders in delivery ${
            totalCounts.inDeliveryOrders > 0
              ? `(${totalCounts.inDeliveryOrders})`
              : ''
          }`}
        />
        <Tab
          label={`Finished Orders ${
            totalCounts.finishedOrders > 0
              ? `(${totalCounts.finishedOrders})`
              : ''
          }`}
        />
      </Tabs>

      <div className="orders-summary">
        <span>
          {' '}
          Today: (<b>{totalCounts.todaysOrdersCount}</b>)
        </span>
        <span>
          {' '}
          This Week: (<b>{totalCounts.weeklyOrdersCount}</b>)
        </span>
        <span>
          {' '}
          This Month: (<b>{totalCounts.monthlyOrdersCount}</b>)
        </span>
      </div>

      <div className="orders-table-wrapper">
        {value === 0 && (
          <Table
            noBorder={true}
            tableConfig={config}
            // onView={onView}
            apidata="orders"
            countryid={countryid}
            url={`${GET_ORDERS}/active`}
            exportCsv={exportCsv}
          />
        )}
      </div>
      <div className="orders-table-wrapper">
        {value === 1 && (
          <Table
            noBorder={true}
            tableConfig={config}
            // onView={onView}
            apidata="orders"
            countryid={countryid}
            url={`${GET_ORDERS}/inDelivery`}
            exportCsv={exportCsv}
            // localization={
            //   {
            //     header: {
            //       actions: ''
            //     }
            //   }
            // }
          />
        )}
      </div>
      <div className="orders-table-wrapper">
        {value === 2 && (
          <Table
            noBorder={true}
            tableConfig={columnsConfig}
            key={refreshTrigger}
            // onView={onView}
            apidata="orders"
            countryid={countryid}
            url={`${GET_ORDERS}/finished`}
            exportCsv={exportCsv}
          />
        )}
      </div>
      <Modal
        title="Seller Information"
        visible={isModalVisible}
        onCancel={handleModalClose}
        okText="Close"
        cancelText=""
        footer={
          <Button
            type="primary"
            onClick={handleModalClose}
            label="Close"
          ></Button>
        }
      >
        <div>
          <p>
            <b>Seller Name:</b> {selectedOrder?.food_seller?.user?.name}
          </p>
          <p>
            <b>Seller Email:</b> {selectedOrder?.food_seller?.user?.email_id}
          </p>
          <p>
            <b>Seller Phone Number:</b>
            {selectedOrder?.food_seller?.user?.code}{' '}
            {selectedOrder?.food_seller?.user?.mobile_no}
          </p>
          <p>
            <b>Address:</b>
            {selectedOrder?.food_seller?.address_line1}
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default withRouter(Orders);
